module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": _vm.save
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "col-5 col-md-12"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.question.text))])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 col-md-12"
  }, [_c('label', {
    staticClass: "form-radio",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickSave('y')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.question.ref,
      "value": "y"
    },
    domProps: {
      "checked": _vm._q(_vm.answer.atxt, "y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.answer, "atxt", "y")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Yes\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "form-radio",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quickSave('n')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer.atxt),
      expression: "answer.atxt"
    }],
    attrs: {
      "type": "radio",
      "name": _vm.question.ref,
      "value": "n"
    },
    domProps: {
      "checked": _vm._q(_vm.answer.atxt, "n")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.answer, "atxt", "n")
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" No\n              ")])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fac1f63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/questions/bool.vue
// module id = 481
// module chunks = 1